export enum FlowStatus {
  Draft = 'draft',
  Live = 'live',
  Paused = 'paused',
}
